<template>
  <div
    class="content"
    :class="{
      'electron-teacher-pages': isElectron,
      'teacher-pages': !isElectron,
    }"
  >
    <ul class="tabs-wrap">
      <li
        v-for="item in navList"
        :key="item.key"
        @click="handleClickTab(item)"
        :class="{ active: item.component.includes($route.name) }"
      >
        <div v-if="isElectron">
          <img
            v-if="item.component.includes($route.name)"
            class="active-icon"
            :src="item.activeImg"
            alt=""
          />
          <img v-else class="icon" :src="item.image" alt="" />
        </div>
        {{ item.name }}
      </li>
    </ul>
    <div class="conten-wrap">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      navList: [
        {
          name: "课表",
          key: "LiveList",
          activeImg: require("../../assets/images/learning-center/ke-biao-active.png"),
          image: require("../../assets/images/learning-center/ke-biao.png"),
          component: "LiveList",
        },
        {
          name: "课程",
          key: "TCourses",
          activeImg: require("../../assets/images/learning-center/course-active.png"),
          image: require("../../assets/images/learning-center/course.png"),
          component: ["TCourses", "TCourseDetail"],
        },
      ],
      isElectron: window.isElectron,
    };
  },
  methods: {
    handleClickTab(obj) {
      this.$router.push({ name: obj.key });
    },
  },
};
</script>

<style lang="scss" scoped>
.teacher-pages {
  min-height: calc(100vh - 110px);
  padding: 30px 0 0;
  .tabs-wrap {
    position: fixed;
    float: left;
    width: 120px;
    background: var(--card-bg, #ffffff);
    border-radius: 24px;
    padding: 12px 0;
    li {
      padding: 12px 12px 12px 24px;
      cursor: pointer;
      font-size: 16px;
      color: var(--text-secondary, #{$plain-text-color});
      line-height: 22px;
    }
    .active {
      position: relative;
      font-weight: 600;
      color: var(--text-primary, #{$saas-text-color});
      &::after {
        position: absolute;
        content: " ";
        display: block;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 4px;
        height: 19px;
        background: linear-gradient(
          132deg,
          $linear-gradient-begin 0%,
          $linear-gradient-end 100%
        );
        border-radius: 3px;
      }
    }
  }
  .conten-wrap {
    margin-left: 150px;
    min-height: calc(100vh - #{$side-bar-width});
  }
}

.electron-teacher-pages {
  padding: 10px 0 0;
  .tabs-wrap {
    position: fixed;
    float: left;
    width: 100px;
    background: transparent;
    border-radius: 0;
    padding: 10px 0;
    li {
      display: flex;
      align-items: center;
      width: 80px;
      height: 30px;
      border-radius: 6px;
      padding-left: 10px;
      cursor: pointer;
      font-weight: 400;
      font-size: 14px;
      color: var(--text-secondary, #515350);
      line-height: 20px;
      &:hover {
        background: var(--input-bg, #{$hover-bg-color});
      }
      margin-bottom: 10px;
      .active-icon,
      .icon {
        width: 18px;
        height: 18px;
        margin-right: 4px;
      }
    }
    .active {
      background: linear-gradient(
        132deg,
        rgba($color: #00eb81, $alpha: 0.3) 0%,
        rgba($color: #00c89d, $alpha: 0.3) 100%
      );
      color: var(--text-primary, #0d1400);
      &:hover {
        background: linear-gradient(
          132deg,
          rgba($color: #00eb81, $alpha: 0.3) 0%,
          rgba($color: #00c89d, $alpha: 0.3) 100%
        );
      }
    }
  }
  .conten-wrap {
    position: relative;
    margin-left: 110px;
    min-height: auto;
    &::after {
      top: 0;
      position: absolute;
      left: -15px;
      height: 100%;
      display: block;
      content: "";
      width: 1px;
      background: var(--border-color, #f2f3f4);
    }
  }
}
</style>
